import type { RootState } from "@/reducer";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

// Base selector for UI state
const selectUi = (state: RootState) => state.ui;

// Memoized selectors using createSelector
const selectSelectedLayerId = createSelector(selectUi, (ui) => ui.selectedLayerId);
export function useSelectedLayerId() {
  return useSelector(selectSelectedLayerId);
}

const selectSelectedElementToRemove = createSelector(selectUi, (ui) => ui.selectedElementToRemove);
export function useSelectedElementToRemove() {
  return useSelector(selectSelectedElementToRemove);
}

const selectHeaderVisibilityMode = createSelector(selectUi, (ui) => ui.headerVisibilityMode);
export function useHeaderVisibilityMode() {
  return useSelector(selectHeaderVisibilityMode);
}

const selectFooterVisibilityMode = createSelector(selectUi, (ui) => ui.footerVisibilityMode);
export function useFooterVisibilityMode() {
  return useSelector(selectFooterVisibilityMode);
}

const selectSelectedMap = createSelector(selectUi, (ui) => ui.selectedMap);
export function useSelectedCartographicMap() {
  return useSelector(selectSelectedMap);
}

const selectSelectedPlot = createSelector(selectUi, (ui) => ui.selectedPlot);
export function useSelectedPlot() {
  return useSelector(selectSelectedPlot);
}

const selectSelectedPlotSerieEditParameter = createSelector(selectUi, (ui) => ui.selectedPlotSerieForEditParameter);
export function useSelectedPlotSerieEditParameter() {
  return useSelector(selectSelectedPlotSerieEditParameter);
}

const selectSelectedLayerForEditParameter = createSelector(selectUi, (ui) => ui.selectedLayerForEditParameter);
export function useSelectedLayerForEditParameter() {
  return useSelector(selectSelectedLayerForEditParameter);
}

const selectSelectedLayerForAddParameter = createSelector(selectUi, (ui) => ui.selectedLayerForAddParameter);
export function useSelectedLayerForAddParameter() {
  return useSelector(selectSelectedLayerForAddParameter);
}

const selectSelectedTool = createSelector(selectUi, (ui) => ui.selectedTool);
export function useSelectedTool() {
  return useSelector(selectSelectedTool);
}

const selectSideNavFixed = createSelector(selectUi, (ui) => ui.sideNavFixed);
export function useSideNavFixed() {
  return useSelector(selectSideNavFixed);
}
const selectSideNavOpen = createSelector(selectUi, (ui) => ui.sideNavOpen);
export function useSideNavOpen() {
  return useSelector(selectSideNavOpen);
}
